import React from 'react';
import PropTypes from 'prop-types';
import { Box, withStyles } from '@material-ui/core';
import { Modal } from '@orijinworks/frontend-commons';
import { ADD_FORMS_LABELS, ADD_FORMS_MODAL_TYPE } from './addFormsModal.constants';
import styles, { ADD_FORMS_MODAL_FRAME_STYLES } from './AddFormsModal.styles';
import AddFormsOption from './AddFormsOption';
import AddFormsStatus from './AddFormsStatus';
import { useAddFormsSelection } from './useAddFormsSelection';

function AddFormsModal({ classes, open, forms, loading, error, onClose, onConfirm }) {
  const { isSelected, toggleForm, selectedForms } = useAddFormsSelection(open, forms);

  if (!open) {
    return null;
  }

  const showList = !loading && !error;

  return (
    <Modal
      open={open}
      onClose={onClose}
      onContinue={() => onConfirm(selectedForms)}
      heading={ADD_FORMS_LABELS.HEADING}
      labelledBy={ADD_FORMS_LABELS.HEADING}
      describedBy={ADD_FORMS_LABELS.DESCRIPTION}
      cancelBtnText={ADD_FORMS_LABELS.CANCEL}
      actionBtnText={ADD_FORMS_LABELS.ADD}
      continueButtonProps={{ disabled: selectedForms.length === 0 }}
      showCrossIcon
      modalType={ADD_FORMS_MODAL_TYPE}
      styles={ADD_FORMS_MODAL_FRAME_STYLES}
    >
      <Box className={classes.content} data-testid="add-forms-modal">
        <AddFormsStatus
          classes={classes}
          loading={loading}
          error={error}
          isEmpty={forms.length === 0}
        />
        {showList &&
          forms.map((form) => (
            <AddFormsOption
              key={form.id}
              classes={classes}
              form={form}
              checked={isSelected(form.id)}
              onToggle={toggleForm}
            />
          ))}
      </Box>
    </Modal>
  );
}

AddFormsModal.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  open: PropTypes.bool,
  forms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
  error: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

AddFormsModal.defaultProps = {
  open: false,
  forms: [],
  loading: false,
  error: null,
  onClose: undefined,
  onConfirm: undefined,
};

export default withStyles(styles)(AddFormsModal);
